import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const DecksIcon = () => (
    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 7h5l2 3h11v7a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
    </svg>
);

const ExamIcon = () => (
    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
    </svg>
);

const HistoryIcon = () => (
    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 12a9 9 0 109-9 9.75 9.75 0 00-6.74 2.74L3 8" />
        <path d="M3 3v5h5M12 7v5l4 2" />
    </svg>
);

const AccountIcon = () => (
    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
);

const MobileBottomNav = ({ onExam, onExamHistory, onAccount, isExamActive = false, isHistoryActive = false }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isDecks = location.pathname === '/app/home';

    const tabs = [
        {
            id: 'decks',
            label: 'Decks',
            Icon: DecksIcon,
            active: isDecks,
            onClick: () => navigate('/app/home'),
            color: 'text-violet-500 dark:text-violet-400',
        },
        {
            id: 'exam',
            label: 'Exam',
            Icon: ExamIcon,
            active: isExamActive,
            onClick: onExam,
            color: 'text-fuchsia-500 dark:text-fuchsia-400',
        },
        {
            id: 'history',
            label: 'History',
            Icon: HistoryIcon,
            active: isHistoryActive,
            onClick: onExamHistory,
            color: 'text-teal-500 dark:text-teal-400',
        },
        {
            id: 'account',
            label: 'Account',
            Icon: AccountIcon,
            active: false,
            onClick: onAccount,
            color: 'text-slate-600 dark:text-slate-300',
        },
    ];

    return (
        <nav
            className="fixed bottom-0 left-0 right-0 z-30 sm:hidden border-t border-slate-200 dark:border-white/10 backdrop-blur-xl bg-white/95 dark:bg-[#080e1a]/96"
            style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
        >
            <div className="flex items-stretch h-14">
                {tabs.map(({ id, label, Icon, active, onClick, color }) => (
                    <button
                        key={id}
                        onClick={onClick}
                        className={`flex-1 flex flex-col items-center justify-center gap-0.5 transition-colors ${
                            active ? color : 'text-slate-400 dark:text-slate-600 active:text-slate-600 dark:active:text-slate-300'
                        }`}
                    >
                        <Icon />
                        <span className="text-[11px] font-medium tracking-tight">{label}</span>
                        {active && (
                            <span className="absolute bottom-0 w-8 h-0.5 rounded-full bg-current opacity-60" />
                        )}
                    </button>
                ))}
            </div>
        </nav>
    );
};

export default MobileBottomNav;
